// src/locales.gen.ts
var LOCALES = [
  "en",
  "es",
  "de",
  "ja",
  "ko",
  "fr",
  "it",
  "nl",
  "tr",
  "sv"
];
var SALES_SITE_LOCALES = ["en", "es", "de"];
var LOCALE_EXPERIMENTAL = [
  "ja",
  "ko",
  "fr",
  "it",
  "nl",
  "tr",
  "sv"
];
var LOCALE_EXPERIMENTAL_NEWS = ["ja", "ko"];
var LOCALE_EXPERIMENTAL_WEB = [
  "ja",
  "ko",
  "fr",
  "it",
  "nl",
  "tr",
  "sv"
];
var LOCALE_ENABLED = [
  "en",
  "es",
  "de",
  "ja",
  "ko",
  "fr",
  "it",
  "nl",
  "tr",
  "sv"
];
var LOCALE_ENABLED_NEWS = ["en", "es", "de", "ja", "ko"];
var LOCALE_ENABLED_WEB = [
  "en",
  "es",
  "de",
  "ja",
  "ko",
  "fr",
  "it",
  "nl",
  "tr",
  "sv"
];
var LOCALE_SEO_INDEXABLE = [
  "en",
  "es",
  "de",
  "ja",
  "ko",
  "fr",
  "it",
  "nl",
  "tr",
  "sv"
];
var LOCALE_SEO_INDEXABLE_NEWS = [
  "en",
  "es",
  "de",
  "ja",
  "ko"
];
var LOCALE_SEO_INDEXABLE_WEB = [
  "en",
  "es",
  "de",
  "ja",
  "ko",
  "fr",
  "it",
  "nl",
  "tr",
  "sv"
];

// src/locales.ts
function isLocale(locale) {
  return LOCALES.includes(locale);
}
function isEnabled(locale, app = "global") {
  if (app === "web") {
    return LOCALE_ENABLED_WEB.includes(
      locale
    );
  }
  if (app === "news") {
    return LOCALE_ENABLED_NEWS.includes(
      locale
    );
  }
  return LOCALE_ENABLED.includes(locale);
}
function isExperimental(locale, app = "global") {
  if (app === "web") {
    return LOCALE_EXPERIMENTAL_WEB.includes(
      locale
    );
  }
  if (app === "news") {
    return LOCALE_EXPERIMENTAL_NEWS.includes(
      locale
    );
  }
  return LOCALE_EXPERIMENTAL.includes(
    locale
  );
}
function isSEOIndexable(locale, app = "global") {
  if (app === "web") {
    return LOCALE_SEO_INDEXABLE_WEB.includes(
      locale
    );
  }
  if (app === "news") {
    return LOCALE_SEO_INDEXABLE_NEWS.includes(
      locale
    );
  }
  return LOCALE_SEO_INDEXABLE.includes(
    locale
  );
}
function hasSalesSiteTranslation(locale) {
  return SALES_SITE_LOCALES.includes(
    locale
  );
}
export {
  LOCALES,
  LOCALE_ENABLED,
  LOCALE_ENABLED_NEWS,
  LOCALE_ENABLED_WEB,
  hasSalesSiteTranslation,
  isEnabled,
  isExperimental,
  isLocale,
  isSEOIndexable
};
